import OpportunityDetails from "./OpportunityDetails";

export default OpportunityDetails;
